(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-stories-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blog-stories-carousel')) {
    class BlogStoriesCarousel extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.blog-stories');
        this.slides = [...this.querySelectorAll('.blog-stories__slide')];
        this.prev = this.root.querySelector('[data-prev]');
        this.next = this.root.querySelector('[data-next]');
        this.dotGroups = [...this.root.querySelectorAll('[data-dots]')];

        this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
        this.next?.addEventListener('click', () => this.goTo(this.index + 1));
        this.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => {
          this.buildDots();
          this.update();
        });
        this.buildDots();
        this.update();
      }

      /* One dot per scroll position (not per card), like the reference carousel. */
      buildDots() {
        const count = this.maxIndex + 1;
        this.dotGroups.forEach((group) => {
          if (group.children.length === count) return;
          group.innerHTML = '';
          if (count < 2) return;
          for (let index = 0; index < count; index++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'blog-stories__dot';
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.addEventListener('click', () => this.goTo(index));
            group.appendChild(dot);
          }
        });
      }

      get step() {
        if (this.slides.length < 2) return this.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }

      get maxIndex() {
        return Math.max(0, Math.ceil((this.scrollWidth - this.clientWidth) / this.step - 0.05));
      }

      goTo(index) {
        const target = Math.max(0, Math.min(index, this.maxIndex));
        this.scrollTo({ left: target * this.step, behavior: 'smooth' });
      }

      update() {
        const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;
        this.index = atEnd ? this.maxIndex : Math.round(this.scrollLeft / this.step);
        if (this.prev) this.prev.disabled = this.scrollLeft <= 2;
        if (this.next) this.next.disabled = atEnd;

        this.dotGroups.forEach((group) => {
          [...group.children].forEach((dot, i) => {
            const distance = Math.abs(i - this.index);
            dot.dataset.distance = distance <= 1 ? String(distance) : distance === 2 ? '2' : 'far';
            dot.setAttribute('aria-current', distance === 0 ? 'true' : 'false');
          });
        });
      }
    }

    customElements.define('blog-stories-carousel', BlogStoriesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
